<span class="icon-loading inline-block {$$props.class || ''}" />
